import React, { Fragment, useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
// import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Grid, Tabs, Tab, TextField, TableHead } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { accountService, userService } from '../../../services';
import { DashboardHeader } from '../../../components/Header/DashboardHeader';
import useStyles from './AccountDetails.style';
import { Radio } from '@material-ui/core';
import { AccountDetailsProps } from '../../../schemas/account.schema';
import { RoutesFun } from '../../../schemas';
import { Navigation } from '../../../components/Navigation/Navigation';

import { SubscriptionModal } from '../../../components/Modals/AddSubscription/AddSubscription';
import './AccountDetails.css';
import { useSelector, useDispatch } from 'react-redux';
import { accountState, uiState } from '../../../store/index';
import { accountActions } from '../../../store/accountSlice';
import { TablePaginationFooter } from '../../../components/Pagination/TablePaginationFooter';
import { handleError } from '../../../utils/config';
import { ALL_VALUE } from '../../Invoice/config';
import Loading from '../../../components/Loading/Loading';
import { Tooltip } from '@mui/material';
import AlertModal from '../../../components/Modals/Alert/Alert';
import CustomSnackBar from '../../../components/MasterComponent/CustomSnackbar/CustomSnackBar';
import ProtectedComponent from '../../../components/ProtectedComponent/ProtectedComponent';
import { PERMISSION_KEY, PERMISSION_LEVELS } from '../../../utils/constants';

const accountPageStorageKeys = {
  ACCOUNTS_ROWS_PER_PAGE: 'ACCOUNTS_ROWS_PER_PAGE',
  ACCOUNTS_PAGE_NO: 'ACCOUNTS_PAGE_NO',
};

const getAccountsRowsPerPage = () => {
  const rowsPerPage =
    localStorage.getItem(accountPageStorageKeys.ACCOUNTS_ROWS_PER_PAGE) || 10;
  return +rowsPerPage;
};

const setAccountsRowsPerPage = (value: string) => {
  localStorage.setItem(accountPageStorageKeys.ACCOUNTS_ROWS_PER_PAGE, value);
};

const getAccountsPageNo = () => {
  const pageNo =
    localStorage.getItem(accountPageStorageKeys.ACCOUNTS_PAGE_NO) || 0;
  return +pageNo;
};

const setAccountsPageNo = (value: string) => {
  localStorage.setItem(accountPageStorageKeys.ACCOUNTS_PAGE_NO, value);
};

export const AccountDetailsPage2: React.FC = () => {
  const Routes = RoutesFun();
  const dispatch = useDispatch();
  const accountData = useSelector(accountState);
  const selectedAccount = accountData.selectedAccount;
  const [user, setUser] = useState<any>();
  const isAccountSelected = accountData.isAccountSelected;
  const classes = useStyles();
  const [loader, setLoader] = React.useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [searchInput, setSearchInput] = React.useState('');
  const [subscriptionBtn, setSubscriptionBtn] = React.useState(true);
  const [isDeleteAccount, setIsDeleteAccount] = useState<boolean>(false);
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<
    'info' | 'success' | 'error' | 'warning'
  >('info');
  const [currentAccountData, setCurrentAccountData] = useState<any>(null);
  const closeDeleteAccountModalHandler = () => {
    setCurrentAccountData(null);
    setIsDeleteAccount(false);
  };
  const roleId = user?.RoleId;
  let cloudProviderInitial: string = 'NULL';
  let valueInitial: number = 0;
  let initialPage: number = 0;

  if (user?.CloudProvider) {
    cloudProviderInitial = user?.CloudProvider.toUpperCase();

    valueInitial =
      cloudProviderInitial === 'AWS'
        ? 0
        : cloudProviderInitial === 'AZURE'
        ? 1
        : cloudProviderInitial === 'GOOGLE'
        ? 2
        : 0;

    if (!isAccountSelected) {
      initialPage = 0;
    } else {
      initialPage = getAccountsPageNo();
    }
  }

  const userDataHandler = async () => {
    try {
      const userData = await userService.getUserDetails();
      if (userData) {
        setUser(userData);
      }
      return userData;
    } catch (e: any) {
      if (e === 'Network Error') {
        setNetworkError(true);
      }
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
    }
  };

  const handleSnackBarClose = () => {
    setSnackBarOpen(false);
  };

  const validateARN = async (row: AccountDetailsProps) => {
    try {
      setLoader(true);

      // Call API
      const response = await accountService.validateARN(row);

      const result = response?.data?.result?.message; // Access message inside result

      // Check if response has valid message or credentials
      if (!result) {
        setSnackBarMessage('Could not verify account.');
        setSnackBarOpen(true);
        setSnackbarSeverity('info');
        return;
      }

      if (result === 'Account successfully verified') {
        setSnackBarMessage('Account successfully verified');
        setSnackbarSeverity('success');
      } else {
        setSnackBarMessage('Account could not be verified');
        setSnackbarSeverity('error');
      }
      setSnackBarOpen(true);
    } catch (e: any) {
      // Handle network error
      if (e?.message === 'Network Error') {
        setNetworkError(true);
        setSnackBarMessage('Network error occurred.');
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
      }

      // Handle other errors
      if (e?.response?.data?.message) {
        handleError(e, history);
        setSnackBarMessage(e.response.data.message);
        setSnackbarSeverity('error');
        setSnackBarOpen(true);
      }
    } finally {
      setLoader(false);
      getAllAccounts(); // refresh account list
    }
  };

  const [cloudProvider, setcloudProvider] = React.useState<string>(
    cloudProviderInitial
  );
  const [value, setValue] = React.useState(valueInitial);
  const [data, setData] = React.useState<AccountDetailsProps[]>([]);
  const [filteredData, setFilteredData] = React.useState<
    AccountDetailsProps[] | null
  >(null);

  useEffect(() => {
    userDataHandler();
  }, []);

  //----------------------- table-------------------------
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(getAccountsRowsPerPage);

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    filteredData && page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - filteredData.length)
      : 0;

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setAccountsPageNo(String(newPage));
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    if (data.length > 0) {
      setAccountsRowsPerPage(event.target.value);
      setRowsPerPage(parseInt(event.target.value, 10));
    } else {
      setRowsPerPage(10);
    }

    setAccountsPageNo(String(0));
    setPage(0);
  };
  //--------------------------------------------------------------

  useEffect(() => {
    setcloudProvider(cloudProviderInitial);
    setValue(valueInitial);
    setPage(initialPage);
  }, [cloudProviderInitial, valueInitial]);

  const [awsData, setAwsData] = React.useState<AccountDetailsProps[]>([]);
  const [azureData, setAzureData] = React.useState<AccountDetailsProps[]>([]);
  const [googleData, setGoogleData] = React.useState<AccountDetailsProps[]>([]);

  const [errMsg, setErrMsg] = React.useState('');
  const history = useHistory();

  const [isNetworkError, setNetworkError] = React.useState(false);
  const [openSubscriptionModal, setOpenSubscriptionModal] = React.useState(
    false
  );
  const [selectedAccountData, setSelectedAccountData] = React.useState<any>([]);

  const { collapsed } = useSelector(uiState);

  const handleSubscriptionModal = () => {
    setOpenSubscriptionModal(true);
  };

  const onClose = () => {
    setOpenSubscriptionModal(false);
    getAllAccounts();
  };

  const getCloudProvider = (value: number): string => {
    let cloudProvider: string = '';
    if (value === 0) {
      cloudProvider = 'AWS';
    }
    if (value === 1) {
      cloudProvider = 'AZURE';
    }
    if (value === 2) {
      cloudProvider = 'GOOGLE';
    }
    return cloudProvider;
  };

  const handleChange = (
    event: React.ChangeEvent<Record<string, unknown>>,
    value: number
  ) => {
    if (value === 1) return;
    const cloudProvider: string = getCloudProvider(value);
    setcloudProvider(cloudProvider);
    setValue(value);
    fetchData(value);
    setSearchInput('');

    // setSubscriptionFetchedData([]);
    setAccountsPageNo(String(0));
    setPage(0);
  };

  // useEffect(() => {
  //   filteredData && selectAccount(cloudProvider, filteredData[0]?.Id);
  // }, [cloudProvider, filteredData]);

  const fetchData = (value: number) => {
    switch (value) {
      case 0:
        setData(awsData);
        setFilteredData(awsData);
        break;
      case 1:
        setData(azureData);
        setFilteredData(azureData);
        break;
      case 2:
        setData(googleData);
        setFilteredData(googleData);
        break;
      default:
        break;
    }
  };

  const handleClick = () => {
    history.push(Routes.CreateAccount);
  };

  const getAllAccounts = async (from?: string) => {
    try {
      setLoader(true);
      const result = await accountService.getAccountDetails(
        cloudProvider,
        true,
        true
      );
      setFilteredData(result);

      switch (value) {
        case 0:
          setAwsData(result);
          break;
        case 1:
          setAzureData(result);
          break;
        case 2:
          setGoogleData(result);
          break;
        default:
          break;
      }

      if (
        result.length % rowsPerPage === 0 &&
        page !== 0 &&
        from === 'delete'
      ) {
        setPage((prevPage) => {
          setAccountsPageNo(String(prevPage - 1));
          return prevPage - 1;
        });
      }
    } catch (e: any) {
      if (e === 'Network Error') {
        setNetworkError(true);
      }
      if (e && e.error && e.error.message) {
        handleError(e, history);
      }
    } finally {
      setLoader(false);
    }
  };

  const openEditPage = (row: any) => {
    // const cloudProvider: string = getCloudProvider(value);
    const company = localStorage.getItem('CompanyName');

    history.push({
      pathname: `/${company}/accounts/edit-account/${cloudProvider}/${row.Id}`,
    });
  };

  const deleteAccountDetails = async (row: AccountDetailsProps) => {
    try {
      setDeleteLoader(true);
      const obj: { Id: number; CloudProvider: string } = {
        Id: row.Id,
        CloudProvider: cloudProvider,
      };
      await accountService.deleteAccount(obj);
      let accountData;

      if (row.CloudProvider === selectedAccount?.CloudProvider) {
        accountData = { CloudProvider: 'AWS' };
        dispatch(
          accountActions.replaceAccountState({
            selectedAccount: accountData,
            isAccountSelected: false,
          })
        );
      } else {
        window.location.reload();
      }

      dispatch(
        accountActions.replaceAccountState({
          ...selectedAccount,
          selectedAccountName: ALL_VALUE,
          selectedSubscriptionName: ALL_VALUE,
          selectedAccountId: ALL_VALUE,
          selectedSubscriptionId: ALL_VALUE,
          selectedSubData: [],
        })
      );
    } catch (e: any) {
      if (e === 'Network Error') {
        setNetworkError(true);
      }
      if (e && e.error && e.error.message) {
        setErrMsg(e.error.message);
        // setMsg(true);
        handleError(e, history);
      }
    } finally {
      setDeleteLoader(false);
      setIsDeleteAccount(false);
      getAllAccounts();
    }
  };

  const handleFieldChange = (target: any) => {
    setSearchInput(target.value);
  };

  const searchAccounts = () => {
    if (searchInput === '') {
      fetchData(value);
    } else {
      globalSearch(searchInput);
    }
  };

  const handleKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      searchAccounts();
    }
  };

  const globalSearch = (searchText: string) => {
    if (searchText) {
      const filteredData = data.filter((value: any) => {
        return (
          value.AliasName.charAt(0).toLowerCase() ===
            searchText.toLowerCase() ||
          value.AliasName.toLowerCase().includes(searchText.toLowerCase()) ||
          value.ServiceType.charAt(0).toLowerCase() ===
            searchText.toLowerCase() ||
          value.ServiceType.toLowerCase().includes(searchText.toLowerCase()) ||
          value.AzureId.charAt(0).toLowerCase() === searchText.toLowerCase() ||
          value.AzureId.toLowerCase().includes(searchText.toLowerCase()) ||
          value.createdAt.toLowerCase().includes(searchText.toLowerCase()) ||
          value.updatedAt.toLowerCase().includes(searchText.toLowerCase())
        );
      });
      setFilteredData(filteredData);

      if (filteredData.length <= 0) {
        setRowsPerPage(10);
      }
    }
  };

  const selectAccount = async (selectedCloudProvider: any, Id: any) => {
    try {
      if (selectedCloudProvider) {
        const params = {
          Id,
          CloudProvider: selectedCloudProvider,
        };
        await accountService.setAccount(params);

        const accountData = await accountService.getSelectedAccount();

        dispatch(
          accountActions.replaceAccountState({
            selectedAccount: accountData,
            isAccountSelected: true,
            selectedAccountName: ALL_VALUE,
            selectedSubscriptionName: ALL_VALUE,
            selectedAccountId: ALL_VALUE,
            selectedSubscriptionId: ALL_VALUE,
            selectedSubData: [],
          })
        );
      }
      setSelectedAccountData([accountData]);
    } catch (e: any) {
      if (e === 'Network Error') {
        setNetworkError(true);
      }
      if (e && e.error && e.error.message) {
        setErrMsg(e.error.message);
        // setMsg(true);
        handleError(e, history);
      }
    }
  };

  // useEffect(() => {
  //   if (filteredData) {
  //     selectAccount(cloudProvider, filteredData[0]?.Id);
  //   }
  // }, [filteredData]);

  useEffect(() => {
    cloudProvider !== 'NULL' && getAllAccounts();
  }, [value, cloudProvider]);

  useEffect(() => {
    {
      selectedAccount && setSelectedAccountData([selectedAccount]);
    }
  }, [value, cloudProvider, selectedAccount]);

  useEffect(() => {
    if (cloudProvider == 'AZURE') {
      setSubscriptionBtn(true);
    } else {
      setSubscriptionBtn(false);
    }
  }, [cloudProvider]);

  if (isNetworkError) {
    throw new Error('Network Error');
  }

  return (
    <Fragment>
      {/* {loader ? <LoadingScreen /> : ''} */}
      <DashboardHeader />
      <div className="innerContainer">
        <div className="splitLayout">
          <div className={`leftNav ${collapsed ? 'collapsed' : ''}`}>
            <Navigation />
          </div>

          {
            <div className="rightContent">
              <CustomSnackBar
                message={snackBarMessage}
                onClose={handleSnackBarClose}
                open={snackBarOpen}
                severity={snackbarSeverity}
              />
              <div className="innerRightContent">
                <div
                  className={`${
                    roleId !== 2 ? 'flex-rowReverse' : ''
                  } topSearchRefBar p-static`}
                >
                  {roleId == 2 && (
                    <div className="addAccountBtns">
                      <button
                        className="btn btn-primary px-15 accountBtn"
                        onClick={handleClick}
                      >
                        <span className="addIcon">+</span>
                        <span className="ml-5">NEW ACCOUNT</span>
                      </button>

                      {subscriptionBtn &&
                      selectedAccount &&
                      selectedAccount.CloudProvider.toUpperCase() ===
                        'AZURE' ? (
                        <button
                          className="btn btn-outline-primary px-15 accountBtn ml-20 "
                          onClick={handleSubscriptionModal}
                        >
                          <span className="addIcon">+</span>
                          <span className="ml-5">SUBSCRIPTION</span>
                        </button>
                      ) : null}
                    </div>
                  )}

                  <div className="searchBar pr-0 pl-0 w-70 accSearch">
                    <TextField
                      label="SEARCH ACCOUNT"
                      id="filled-size-small"
                      // inputRef={searchRef}
                      // defaultValue={uData}
                      variant="outlined"
                      size="small"
                      // onBlur={(e) => searchValue(e.target)}
                      onChange={(e) => handleFieldChange(e.target)}
                      className="w-100"
                      onKeyDown={handleKeyDown}
                    />
                    <input
                      type="submit"
                      value="Search"
                      className="btn-primary btn ml-10"
                      onClick={searchAccounts}
                    />
                  </div>
                </div>

                <Grid container spacing={0}>
                  <Grid
                    item
                    md={12}
                    sm={12}
                    xs={12}
                    className={classes.headerGrid}
                  >
                    <Tabs
                      value={value}
                      indicatorColor="primary"
                      textColor="primary"
                      onChange={handleChange}
                      aria-label="disabled tabs example"
                      className="tabCont"
                    >
                      <Tab
                        label={
                          <div className="flex">
                            <div>
                              <Radio
                                checked={cloudProvider == 'AWS' ? true : false}
                                value="a"
                                color="primary"
                                name="radio-button-demo"
                              />
                            </div>

                            <div className="mt-5 ml-10">AWS</div>
                          </div>
                        }
                        value={0}
                      />
                      <Tab
                        label={
                          <div className="flex">
                            <div>
                              <Radio
                                checked={
                                  cloudProvider == 'AZURE' ? true : false
                                }
                                // onClick={() =>
                                //   selectAccount('AZURE', filteredData[0].Id)
                                // }
                                value="a"
                                color="primary"
                                name="radio-button-demo"
                                disabled
                              />
                            </div>

                            <div className="mt-5 ml-10">AZURE</div>
                          </div>
                        }
                        value={1}
                        disabled
                      />
                      {/* <Tab
                        label={
                          <div className="flex">
                            <div>
                              <Radio
                                disabled
                                // onClick={() =>
                                //   selectedAccount?.CloudProvider == 'GOOGLE'
                                //     ? undefined
                                //     : selectAccount('GOOGLE')
                                // }
                                value="a"
                                color="primary"
                                name="radio-button-demo"
                              />
                            </div>

                            <div className="mt-5 ml-10">GOOGLE</div>
                          </div>
                        }
                        value={2}
                      /> */}
                    </Tabs>
                  </Grid>

                  <TableContainer className="accContainer " component={Paper}>
                    <Table
                      aria-label="collapsible table"
                      className="table adminTable adminPanelTable accountListTable"
                    >
                      {/* <TableHead className="admintableHead">
                        <TableRow>
                          <TableCell
                            align="left"
                            className="rowRadio"
                          ></TableCell>
                          <TableCell align="left" className="adminTableheading">
                            CFX Name
                          </TableCell>
                          {value === 0 ? (
                            <TableCell
                              align="left"
                              className="adminTableheading"
                            >
                              IAM User Id
                            </TableCell>
                          ) : null}
                          {value == 1 ? (
                            <TableCell
                              align="left"
                              className="adminTableheading"
                            >
                              Azure Id
                            </TableCell>
                          ) : value == 0 ? (
                            <TableCell
                              align="left"
                              className="adminTableheading"
                            >
                              AWS Id
                            </TableCell>
                          ) : (
                            <TableCell
                              align="left"
                              className="adminTableheading"
                            >
                              GOOGLE Id
                            </TableCell>
                          )}
                          {value == 1 ? (
                            <TableCell
                              align="left"
                              className="adminTableheading"
                            >
                              Type
                            </TableCell>
                          ) : null}
                          <TableCell align="left" className="adminTableheading">
                            Created Date
                          </TableCell>
                          <TableCell align="left" className="adminTableheading">
                            Last Updated
                          </TableCell>
                          <TableCell align="left" className="adminTableheading">
                            Status
                          </TableCell>
                          <TableCell align="left" className="adminTableheading">
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead> */}
                      <TableHead className="admintableHead">
                        <TableRow
                          // className="tableRow collapseTableHeader"
                          style={{ backgroundColor: '#f3f3f3' }}
                        >
                          <TableCell
                            // className="rowName"
                            className="adminTableheading"
                          >
                            CFx Name
                          </TableCell>
                          <TableCell
                            // className="rowName"
                            className="adminTableheading"
                          >
                            {value === 0
                              ? 'Account Name'
                              : value === 1
                              ? 'Azure Name'
                              : 'Account Name'}
                          </TableCell>
                          <TableCell
                            // className="rowId"
                            className="adminTableheading"
                          >
                            {value === 0
                              ? 'IAM User Id'
                              : value === 1
                              ? 'Subscription Id'
                              : 'Subscription Id'}
                          </TableCell>
                          {value === 1 ? (
                            <TableCell
                              align="left"
                              // className="rowServiceType"
                              className="adminTableheading"
                            >
                              Type
                            </TableCell>
                          ) : null}
                          <TableCell
                            align="left"
                            // className="rowCurrentUpdated"
                            className="adminTableheading"
                          >
                            Created Date
                          </TableCell>
                          <TableCell
                            align="left"
                            // className="rowCurrentUpdated"
                            className="adminTableheading"
                          >
                            Last Updated
                          </TableCell>
                          <TableCell
                            align="left"
                            // className="rowStatus"
                            className="adminTableheading"
                          >
                            Status
                          </TableCell>
                          {roleId == 2 && (
                            <TableCell
                              align="left"
                              // className="rowAction"
                              className="adminTableheading"
                            >
                              Action
                            </TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {loader ? (
                          <TableRow>
                            <TableCell colSpan={8}>
                              <Loading
                                style={{
                                  height: 'fit-content',
                                  padding: '2rem',
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        ) : (
                          filteredData &&
                          (rowsPerPage > 0
                            ? filteredData.slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                            : filteredData
                          ).map((row: AccountDetailsProps, i: number) => (
                            <TableRow
                              key={'subs' + i}
                              // className="tableRow"
                            >
                              <TableCell
                                // component="th"
                                scope="row"
                                // className="rowName"
                              >
                                <Tooltip
                                  title={row.AliasName}
                                  arrow
                                  aria-label={row.AliasName}
                                >
                                  <>{row.AliasName ? row.AliasName : <>-</>}</>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                // component="th"
                                scope="row"
                                // className="rowName"
                                style={{ maxWidth: '16rem' }}
                              >
                                <Tooltip title={row.Name} arrow>
                                  <div>{row.Name ? row.Name : <>- </>}</div>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                // component="th"
                                scope="row"
                                // className="rowId"
                                style={{ maxWidth: '16rem' }}
                              >
                                <Tooltip
                                  title={
                                    row.SubscriptionId
                                      ? row.SubscriptionId
                                      : row.IAMUserId
                                      ? row.IAMUserId
                                      : '-'
                                  }
                                  arrow
                                >
                                  <div className="rowId text-ellipsis">
                                    {row.SubscriptionId
                                      ? row.SubscriptionId
                                      : row.IAMUserId
                                      ? row.IAMUserId
                                      : '-'}
                                  </div>
                                </Tooltip>
                              </TableCell>
                              {value === 1 ? (
                                <TableCell
                                  align="left"
                                  // className="rowServiceType"
                                >
                                  {row.ServiceType ? row.ServiceType : '-'}
                                </TableCell>
                              ) : null}
                              <TableCell
                                align="left"
                                // className="rowCurrentUpdated"
                              >
                                {row.createdAt ? row.createdAt : '-'}
                              </TableCell>
                              <TableCell
                                align="left"
                                // className="rowCurrentUpdated"
                              >
                                {row.updatedAt ? row.updatedAt : '-'}
                              </TableCell>
                              <TableCell
                                align="left"
                                // className="rowStatus"
                              >
                                {row.Credentials === true ? (
                                  <Tooltip
                                    title={'Account Verified'}
                                    arrow
                                    className="disableIcon"
                                  >
                                    <span className="p-relative text-center d-inline-block w-100 ">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        fill="#155724"
                                        className="bi bi-cloud-check ml-5"
                                        viewBox="0 0 20 10"
                                      >
                                        <path d="M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z" />
                                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                      </svg>
                                    </span>
                                  </Tooltip>
                                ) : (
                                  <Tooltip
                                    title={
                                      cloudProvider === 'AZURE'
                                        ? 'Invalid Request: This may happen if there are no active subscriptions for the tenant. Check to make sure you have the correct tenant ID. Check with your subscription administrator.'
                                        : 'Invalid Client TokenId: The security token included in the request is invalid.'
                                    }
                                    arrow
                                    className="disableIcon"
                                  >
                                    <span className="p-relative text-center d-inline-block w-100 ">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="25"
                                        height="25"
                                        fill="red"
                                        className="bi bi-x-circle-fill ml-5"
                                        viewBox="0 0 25 15"
                                      >
                                        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
                                      </svg>
                                    </span>
                                  </Tooltip>
                                )}
                              </TableCell>
                              {roleId == 2 && (
                                <TableCell
                                  align="left"
                                  // className="rowAction"
                                >
                                  <div className="d-flex">
                                    <span
                                      className="mr-5 cursor-pointer"
                                      onClick={() => openEditPage(row)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-pencil-square"
                                        viewBox="0 0 16 14"
                                      >
                                        <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                        <path d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z" />
                                      </svg>
                                    </span>
                                    <span
                                      className="ml-5 cursor-pointer"
                                      // onClick={() => {
                                      // setCurrentAccountData(subsRow);
                                      // setIsDeleteAccount(true);
                                      // setOpen(false);
                                      // deleteAccountDetails(subsRow);
                                      // }}
                                      onClick={() => {
                                        setCurrentAccountData(row);
                                        setIsDeleteAccount(true);
                                        // setOpen(false);
                                        // deleteAccountDetails(subsRow);
                                      }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-trash"
                                        viewBox="0 0 16 14"
                                      >
                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                                      </svg>
                                    </span>

                                    {!row.Credentials && (
                                      <span
                                        className="ml-10 cursor-pointer"
                                        onClick={() => {
                                          validateARN(row);
                                        }}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="16"
                                          height="18"
                                          fill="currentColor"
                                          className="bi bi-verify"
                                          viewBox="0 0 16 14"
                                        >
                                          <path d="M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z" />
                                          <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                        </svg>
                                      </span>
                                    )}
                                  </div>
                                </TableCell>
                              )}
                            </TableRow>
                            // <AccountRow
                            //   key={'data' + i}
                            //   row={row}
                            //   // selectAccount={selectAccount}
                            //   value={value}
                            //   cloudProvider={cloudProvider}
                            //   openEditPage={openEditPage}
                            //   deleteAccountDetails={deleteAccountDetails}
                            // />
                          ))
                        )}
                        {!loader &&
                        filteredData &&
                        filteredData.length === 0 &&
                        emptyRows >= 0 ? (
                          <TableRow className="tableContent">
                            <TableCell colSpan={12}>
                              <>
                                {value == 0 || value == 1
                                  ? ' No result found'
                                  : ' Coming Soon'}
                              </>
                            </TableCell>
                          </TableRow>
                        ) : null}
                      </TableBody>

                      {filteredData && filteredData.length > 10 ? (
                        <TablePaginationFooter
                          filteredData={filteredData}
                          rowsPerPage={rowsPerPage}
                          page={page}
                          handleChangePage={handleChangePage}
                          handleChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                      ) : null}
                    </Table>
                  </TableContainer>
                </Grid>
              </div>
            </div>
          }
        </div>
      </div>
      )
      {openSubscriptionModal ? (
        <SubscriptionModal
          show={openSubscriptionModal}
          onClose={onClose}
          subscriptionDetail={selectedAccountData}
        />
      ) : null}
      {isDeleteAccount && (
        <AlertModal
          show={isDeleteAccount}
          headerMsg="Delete"
          buttonType="danger"
          onClose={closeDeleteAccountModalHandler}
          metaData={`Are you sure you want to delete ${currentAccountData?.AliasName} Account? This action cannot be undone.`}
          alertFunction={() => deleteAccountDetails(currentAccountData)}
          buttonMsg="Delete"
          requireConfirmation={true}
          confirmationMsg="I understand that this will permanently delete this account"
          isLoading={deleteLoader}
        />
      )}
    </Fragment>
  );
};
